import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import LineChart from '../components/charts/LineChart';
import PieChart from '../components/charts/PieChart';
import data from '../mock/DataQualityIssues.json';
import './DataQualityInsights.css';

function DataQualityInsights() {
  const [overview, setOverview] = useState({});
  const [issueTypes, setIssueTypes] = useState({});
  const [issueTrend, setIssueTrend] = useState([]);
  const [pendingIssues, setPendingIssues] = useState({});

  useEffect(() => {
    // Set data from JSON file
    setOverview(data.overview);
    setIssueTypes(data.issueTypes);
    setIssueTrend(data.issueTrend);
    setPendingIssues(data.pendingIssues);
  }, []);
  return (
    <div>
      <Row>
        <Col xl={20} lg={20} md={18} sm={24} xs={24}>
          <div className="dsqi-title">Overview</div>

          <div className="dsqi-row">
            <div className="single-card">
              <div className="single-card-heading">Accuracy</div>
              <div className="single-card-value">{overview.accuracy}</div>
            </div>
            <div className="single-card">
              <div className="single-card-heading">Uniqueness</div>
              <div className="single-card-value">{overview.uniqueness}</div>
            </div>
            <div className="single-card">
              <div className="single-card-heading">Completeness</div>
              <div className="single-card-value">{overview.completeness}</div>
            </div>
            <div className="single-card">
              <div className="single-card-heading">Consistency</div>
              <div className="single-card-value">{overview.consistency}</div>
            </div>
          </div>
          <Row gutter={16}>
            <Col span={12}>
              <PieChart issueTypes={issueTypes} />
            </Col>
            <Col span={12}>
              <LineChart issueTrend={issueTrend} />
            </Col>
          </Row>
        </Col>

        <Col xl={4} lg={4} md={6} sm={24} xs={24}>
          <div className="dsqi-pending-issues">Pending issues</div>
          <Row gutter={16}>
            <Col span={12}>
              <div className="dsqi-single-card">
                <div className="single-card-heading">Total</div>
                <div className="single-card-value" style={{ color: '#2E86C1' }}>
                  {pendingIssues.total}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className="dsqi-single-card">
                <div className="single-card-heading">Emergency</div>
                <div className="single-card-value" style={{ color: 'red' }}>
                  {pendingIssues.emergency}
                </div>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <div className="dsqi-single-card">
                <div className="single-card-heading">High</div>
                <div className="single-card-value" style={{ color: '#D35400' }}>
                  {pendingIssues.high}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className="dsqi-single-card">
                <div className="single-card-heading">Low</div>
                <div className="single-card-value" style={{ color: 'orange' }}>
                  {pendingIssues.low}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export default DataQualityInsights;
